import { render, staticRenderFns } from "./ReportDocumentActions.vue?vue&type=template&id=9d633a40"
import script from "./ReportDocumentActions.vue?vue&type=script&lang=ts"
export * from "./ReportDocumentActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports